import { Injectable } from '@angular/core';
import {
  CmsPageAdapter,
  CmsPageConnector,
  CmsStructureConfigService,
  CmsStructureModel,
  PageContext,
} from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

// Какого то хуя, спартакусяне 400 ошибки запроса страниц обрабатывают как будто это не ошибка, а статическая страница без бэка.
// Статические страницы, не ходят на бэк а вся конфигурация заводится в CmsPageConfig.
// Разумеется, для 400 там нихуя не лежит(да и в принципе там поле конфига страниц у нас не заполнено).
// При попытке помержить отсутствие(нулл) статического конфига с захардкоженым пустым объектом({}) он и погибал.

@Injectable({
  providedIn: 'root',
})
export class CustomCmsPageConnector extends CmsPageConnector {
  constructor(
    protected cmsPageAdapter: CmsPageAdapter,
    protected cmsStructureConfigService: CmsStructureConfigService,
  ) {
    super(cmsPageAdapter, cmsStructureConfigService);
  }

  get(pageContext: PageContext): Observable<CmsStructureModel> {
    return this.cmsStructureConfigService.shouldIgnoreBackend(pageContext.id).pipe(
      switchMap((loadFromConfig) => {
        if (!loadFromConfig) {
          return this.cmsPageAdapter.load(pageContext);
        } else {
          return of({});
        }
      }),

      switchMap((page) => this.customMergeDefaultPageStructure(pageContext, page)),
    );
  }

  private customMergeDefaultPageStructure(
    pageContext: PageContext,
    pageStructure: CmsStructureModel,
  ): Observable<CmsStructureModel> {
    return this.cmsStructureConfigService.mergePageStructure(pageContext.id, pageStructure);
  }
}
